export default {
  paymentIsUnsuccess: 'subscriptions:failure_tariff_change',
  paymentIsSuccess: 'subscriptions:successful_tariff_change',
  tariffWillBeChanged: 'subscriptions:tariff_will_be_changed',
  tariffWasActivated: 'subscriptions:successful_tariff_change',
  emailLowBalance: 'subscriptions:email_low_balance',
  smsLowBalance: 'subscriptions:sms_low_balance',
  pushLowBalance: 'subscriptions:push_low_balance',
  webhookLowBalance: 'subscriptions:webhook_low_balance',
  chargeIsFailedFirstTime: 'subscriptions:failed_period_charge_first_time',
  chargeIsFailedSecondTime: 'subscriptions:failed_period_charge_second_time',
};



// WEBPACK FOOTER //
// ./src/models/NotificationsKeys.js